export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/dashboard"
    },
    {
        id: 7,
        isLayout: true
    },
    {
        id: 8,
        label: "menuitems.apps.text",
        isTitle: true
    },
    {
        id: 9,
        label: "menuitems.calendar.text",
        icon: "bx-calendar",
        link: "/calendar",
    },
    {
        id: 14,
        label: "menuitems.posts.text",
        icon: "bx-send",
        link: "/posts/list"
    },
    {
        id: 15,
        label: "menuitems.contacts.text",
        icon: "bxs-user-detail",
        link: "/users/list",
        isAdmin: true
    },
    {
        id: 16,
        label: "menuitems.masters.text",
        isTitle: true,
        isAdmin: true
    },
    {
        id: 17,
        label: "menuitems.rooms.text",
        icon: "bxs-building",
        link: "/rooms/list",
        isAdmin: true
    },
    {
        id: 18,
        label: "menuitems.subjects.text",
        icon: "bx-spreadsheet",
        link: "/subjects/list",
        isAdmin: true
    },
    {
        id: 19,
        label: "menuitems.items.text",
        icon: "bx-sidebar",
        link: "/items/list",
        isAdmin: true
    },
    {
        id: 20,
        label: "menuitems.years.text",
        icon: "bx-columns",
        link: "/years/list",
        isAdmin: true
    }
];